import contentEditable from '../../content-editable';
import hooks from '../../hooks';
import canBeRichEdited from '../../constraints/verifiers/can-be-rich-edited';
import pastePlainTextHandler from './paste-plain-text-handler';

const documentPasteHandler = (event) => {
  hooks.handlers.onLiveDocumentPaste(event);
  const { srcElement } = event;
  const closestContentEditable = srcElement.closest('[contenteditable]');

  if (!closestContentEditable) return;

  let isEventPrevented = false;

  const preventHandler = () => {
    isEventPrevented = true;
  };

  hooks.handlers.onTextPaste(event, preventHandler);

  if (isEventPrevented) return;

  contentEditable.helpers.handleAdjacentNode();
  contentEditable.handlers.checkpointDelayHandler(event);

  if (canBeRichEdited(closestContentEditable)) {
    contentEditable.handlers.pasteHandler(event);
    return;
  }

  pastePlainTextHandler(event);
};

export default documentPasteHandler;
